import styled from "styled-components"
import { LabelItem } from "../Common/LabelItem"
import React from "react"
import { serviceGoodsList } from "@/component/Filter/services/common/filter"
import { ServiceGoodsListMobileResponse, serviceGoodsListMobile } from "./serviceGoodsList"
import { isErrorMobile100 } from "@/component/PageComponentMobile/error"
import { FilterList } from '../Common/FilterList';
import { PageInfoBase, useGetData } from '@/component/PageComponent/hooks/requst';
import { throttle } from 'lodash'
import { CheckOutline } from "antd-mobile-icons"
import { Image } from '../Common/Image'
import defaultGoodsList from './asset/goods_list_default.png'
import { useRequest } from "ahooks"


const FilterGoodsMobileView = styled.div`


`

const GoodsItemView = styled.div`
  &.list-item-wrap{
    .img{
      width: 60px;
      height: 60px;
      overflow: hidden;
      border-radius: 5px;
    }
    .list-item{
      display: flex;
      height: 80px;
      align-items: start;
      padding-top: 10px;
      .goods-info{
        margin-left: 15px;
        flex: 1;
        overflow: hidden;
        .goods-name{
          font-size: 18px;
          overflow: hidden;
          width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }

`



export interface FilterGoodsMobileProps{
  value:any[]
  onChange:(value:any[])=>void


}


type RequestParams = {search_content?:string} & PageInfoBase


export const FilterGoodsMobile = (props:FilterGoodsMobileProps)=>{
  const [goodsList,setGoodsList] = React.useState<ServiceGoodsListMobileResponse['data']['list']>([])
  const [visible,setVisible] = React.useState(false)
  const [hasMore,setHasMore] = React.useState(true)
  const {runAsync:getGoodsList,loading} = useRequest(async (data:RequestParams)=>{
    let res = await serviceGoodsListMobile(data)
    if(isErrorMobile100(res)){
      return
    }
    setGoodsList((pre)=>{
      let preData = pre
      if(data.page == 1){
        preData = []
      }
      let list =  [...preData,...res.data.data.list]
      let hasMore = res.data.data.list.length > 0 && list.length < Number(res.data.data.count)
      setHasMore(hasMore)
      return list
    })
  },{manual:true})

  const { setParams ,setPageInfo, params,pageInfo, }  = useGetData<{search_content?:string}>({getData:getGoodsList,defaultPageInfo:{page:1,pageSize:20}})
  let _goods = goodsList.map(item=>({...item, label: item.goods_name,value: item.goods_id,})) 
  return <FilterGoodsMobileView>
    <LabelItem
      label='选择商品'
      options={ _goods }
      value={props.value}
      onClick={()=>setVisible(pre=> !pre)}
    />
    <FilterList<{label:string,value:string} & typeof goodsList[0]>
      dataSource={ _goods }
      loading={loading}
      visible={visible}
      value={props.value}
      headerText='选择商品'
      hasMore={hasMore}
      renderItem={ (data)=>{
        const { item ,onChange,index, isChecked } = data
        return <GoodsItemView className={`list-item-wrap`} >
          <div key={index} className="list-item" onClick={() => onChange(item)}> 
            <div>
              <Image  src={ item.goods_picture || defaultGoodsList  } className="img"/>
            </div>
            <div className="goods-info">
              <div className="goods-name">{item.goods_name}</div>
              <div>{ item.goods_num }</div>
              <div>{ item.goods_model }</div>
            </div>
          </div>
          {isChecked && <CheckOutline className='check-arrow' fontSize={20} color="#3487ed" />}
        </GoodsItemView>
      }}
      setKw={(kw)=>{
        setParams({search_content:kw})
      }}
      loadMore={ async ()=>{
        return setPageInfo({...pageInfo,page: ++pageInfo.page,})
      }}
      onChange={(value)=>{
        props.onChange(value)
      }}
      onClose={()=>setVisible(false)}
    />    
  </FilterGoodsMobileView>
}


